import { Button } from '@/plugins/ant-design-vue/tsx-support'
import { ChannelTypeList } from '@/views/channel/const'
import { Component, Mixins } from '@/vue-property-decorator'
import {
  GlobalEventActions,
  GlobalEventActionsTypeEnum
} from '@/context/events'
import { GlobalEvents } from '@/context'
import { createSvgSprite } from '@/utils/business-utils/assets'
import { getCurrentDevice } from '@/utils/Device'
import { useChannelStore } from '@/views/channel/store'
import { useDownloadAppStore } from '@/layouts/components/downloadApp/store'
import { useMainStore } from '@/store/index'
import { windowConfig } from '@/utils/window'
import BaseMixins from './mixin/index'
import BusinessUtils from '@/utils/business-utils'
import Modal from '@/controller/Modal'
import TooltipsComp from '@/components/business-components/tooltips'
import isMobile from '@/utils/isMobile'
import style from './style.module.scss'
const device = getCurrentDevice()
/**通过点击‘下载’按钮弹出框下载提示框 */
@Component<DownlodAppByDefault>({ name: 'DownlodAppByDefault' })
export default class DownlodAppByDefault extends Mixins(BaseMixins) {
  /**是否已经点击过下载按钮 */
  private isClickDownloadBtn = false
  private handleDownloadApp(action: GlobalEventActions) {
    if (action.type == GlobalEventActionsTypeEnum.download_app) {
      // 兜底处理，如果是极速包，不弹出下载款款
      if (windowConfig.speedPackageConfig) {
        return
      }
      const { channelInfo } = useChannelStore()
      if (!channelInfo || this.isSimpleH5SaveShortcutEnv) {
        this.downloadApp()
        return
      }
      const { type } = channelInfo
      // 如果是配置了p2a，那么走p2a的逻辑
      if (type === ChannelTypeList.Pwa2App) {
        GlobalEvents.dispatch({
          type: GlobalEventActionsTypeEnum.PWATOAPP_INSTALL_BY_CHANNEL
        })
      } else {
        this.downloadApp()
      }
    }
  }

  /**
   * @description 环境是h5的保存桌面快捷方式，非马甲包
   */
  private get isSimpleH5SaveShortcutEnv() {
    return this.isInStandaloneMode && !windowConfig.isWgPackage
  }

  /**是否通过PWA打开 */
  private get isInStandaloneMode() {
    return device.isInStandaloneMode()
  }

  created() {
    GlobalEvents.subscribe(this.handleDownloadApp)
  }

  beforeDestroy() {
    GlobalEvents.unsubscribe(this.handleDownloadApp)
  }

  /**
   *  H5初始化下载配置
   */
  private async downloadApp() {
    const { downloadAppReward, brandLogoInfos } = useMainStore()
    const { isSiteCurrencyBelongNewRewardsCurrency } = useDownloadAppStore()
    const formatedDownloadAppReward = this.formatDownloadAppReward
    if (this.isClickDownloadBtn) {
      return
    }
    this.isClickDownloadBtn = true
    const urlslist = await useDownloadAppStore().getDownloadConfig(
      this.downloadApp
    )
    this.isClickDownloadBtn = false

    if (!Array.isArray(urlslist)) {
      return
    }
    Modal.create({
      closable: true,
      hiddenBtns: true,
      class: style.downloadModal,
      width: BusinessUtils.px2rem(600),
      content: () => {
        return (
          <div class={style.downloadContent}>
            <div class={style.logo}>
              <my-img src={brandLogoInfos?.appIconBigPath ?? ''} />
              <span class={style.title}>
                {brandLogoInfos?.installationHint ?? ''}
              </span>
            </div>
            <div
              class={style.wrapperUrlslist}
              ref={'downloadBtnRef'}
              data-clipboard-text={this.getClipBoardParams}
            >
              {urlslist?.map((item, index) => {
                let count = 0
                return (
                  <Button.Tsx
                    key={item.name}
                    type="primary"
                    ghost={!(index % 2)}
                    class={style.downloadItem}
                    onClick={() => {
                      this.handlerDownloadBtn(item, count)
                      count++
                    }}
                  >
                    {!!downloadAppReward &&
                      isSiteCurrencyBelongNewRewardsCurrency && (
                        <TooltipsComp
                          charge={1}
                          top={BusinessUtils.px2rem(-20)}
                          text={formatedDownloadAppReward}
                        />
                      )}
                    <icon-sprite
                      class={style.appIcon}
                      sprite={
                        isMobile().apple.device
                          ? createSvgSprite('comm_icon_xz-ios')
                          : createSvgSprite('comm_icon_xz-android')
                      }
                    />

                    <span class={style.appName}>{item.name}</span>
                  </Button.Tsx>
                )
              })}
            </div>
          </div>
        )
      }
    })
    this.$nextTick(this.createClipBoard)
  }

  render() {
    return <template></template>
  }
}
